import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assests/logo.png';
import './index.css';
import '../pages/LandingPage.css';

const API_DOCS_URL = 'https://docs-waba.hawktrion.com/';
const SUPPORT_CHAT_URL = 'https://wa.me/message/SM7PNA4L467DK1';
const SUPPORT_EMAIL = 'support@hawktrion.com';
const SUPPORT_QR_URL = 'https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=https%3A%2F%2Fwa.me%2Fmessage%2FSM7PNA4L467DK1';

const SeoLandingPage = ({ title, children, hideCta = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <main className="landing-root">
        <div className="stars"></div>
        <header>
          <nav aria-label="Primary navigation">
            <div className="container">
              <div className="nav-in">
                <Link to="/" className="nav-logo">
                  <img src={logo} alt="Hawktrion Logo" style={{ height: '60px', width: 'auto', objectFit: 'contain' }} />
                </Link>
                <ul className="nav-links">
                  <li><a href="/#why">Why Us</a></li>
                  <li><a href="/#features">Features</a></li>
                  <li><a href="/#industries">Industries</a></li>
                  <li><a href="/#pricing">Pricing</a></li>
                  <li><a href={API_DOCS_URL} target="_blank" rel="noopener noreferrer">API Docs</a></li>
                  <li><a href="/#faq">FAQ</a></li>
                  <li><Link to="/signin">Sign In</Link></li>
                </ul>
                <div className="nav-cta">
                  <Link to="/signup" className="btn btn-s desktop-only-btn" style={{ padding: '10px 20px', fontSize: '13px' }}>Book a Demo</Link>
                  <Link to="/signup" className="btn btn-p" style={{ padding: '10px 20px', fontSize: '13px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#0a0f1f">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    Connect
                  </Link>
                  <button
                    className="mobile-menu-btn"
                    onClick={() => setMobileMenuOpen((isOpen) => !isOpen)}
                    aria-label="Toggle menu"
                    aria-expanded={mobileMenuOpen}
                  >
                    {mobileMenuOpen ? '✕' : '☰'}
                  </button>
                </div>
              </div>
            </div>
            {mobileMenuOpen && (
              <div className="mobile-nav-menu">
                <a href="/#why" onClick={() => setMobileMenuOpen(false)}>Why Us</a>
                <a href="/#features" onClick={() => setMobileMenuOpen(false)}>Features</a>
                <a href="/#industries" onClick={() => setMobileMenuOpen(false)}>Industries</a>
                <a href="/#pricing" onClick={() => setMobileMenuOpen(false)}>Pricing</a>
                <a href={API_DOCS_URL} target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)}>API Docs</a>
                <a href="/#faq" onClick={() => setMobileMenuOpen(false)}>FAQ</a>
                <Link to="/signin" onClick={() => setMobileMenuOpen(false)}>Sign In</Link>
                <Link to="/signup" className="btn btn-s" style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }} onClick={() => setMobileMenuOpen(false)}>Book a Demo</Link>
              </div>
            )}
          </nav>
        </header>

        <section className="seo-page-placeholder">
          <div className="container">
            <div className="sec-label"><span className="sec-label-dot"></span> Hawktrion WhatsApp Solutions</div>
            <h1 className="sec-title">{title}</h1>
          </div>
        </section>

        {children}

        {!hideCta && <section className="fcta">
          <div className="container">
            <div className="fcta-in">
              <div className="fcta-tag">Ready to Get Started?</div>
              <h2 className="fcta-title">Connect Your Business on WhatsApp</h2>
              <p className="fcta-sub">Talk with our team about the right WhatsApp solution for your business.</p>
              <div className="fcta-btns">
                <Link to="/signup" className="btn btn-p btn-xl">Connect Your WhatsApp</Link>
                <a href={SUPPORT_CHAT_URL} target="_blank" rel="noopener noreferrer" className="btn btn-s btn-xl">Chat with Support</a>
              </div>
            </div>
          </div>
        </section>}

        <footer>
          <div className="container">
            <div className="foot-in">
              <div className="foot-brand">
                <img src={logo} alt="Hawktrion Logo" style={{ height: '34px', width: 'auto', objectFit: 'contain', mixBlendMode: 'screen', display: 'block', marginBottom: '4px' }} />
                <div className="foot-copy">© 2026 Hawktrion Technologies. All rights reserved.</div>
                <div className="foot-copy">Support: <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: 'var(--cyan)', textDecoration: 'none' }}>{SUPPORT_EMAIL}</a></div>
              </div>
              <div className="foot-right">
                <div className="foot-links">
                  <a href="/#privacy">Privacy Policy</a>
                  <a href="/#terms">Terms</a>
                  <a href={`mailto:${SUPPORT_EMAIL}`}>Contact</a>
                  <a href="/#pricing">Pricing</a>
                  <a href={API_DOCS_URL} target="_blank" rel="noopener noreferrer">API Docs</a>
                  <a href="/#why">About</a>
                </div>
                <a href={SUPPORT_CHAT_URL} target="_blank" rel="noopener noreferrer" className="foot-qr" aria-label="Open WhatsApp support chat">
                  <img src={SUPPORT_QR_URL} alt="Scan to chat with Hawktrion support on WhatsApp" className="foot-qr-image" />
                  <span className="foot-qr-copy">Scan for WhatsApp support</span>
                </a>
              </div>
            </div>
          </div>
        </footer>

        <a href={SUPPORT_CHAT_URL} target="_blank" rel="noopener noreferrer" className="wa-sticky" aria-label="Chat on WhatsApp">
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-12.5 7.3L3 20l1.2-5.3A8.4 8.4 0 1 1 21 11.5Z" /><path d="M8.5 9.5c.4 2.2 2.3 4.1 4.5 4.5l1.2-1.2 2 .9c-.2 1.2-1.2 2-2.5 2-3.4-.6-6.1-3.3-6.7-6.7 0-1.3.8-2.3 2-2.5l.9 2-1.4 1Z" /></svg>
          <span className="wa-sticky-label">Chat with us</span>
          <span className="wa-sticky-ping"></span>
        </a>
      </main>
    </>
  );
};

export default SeoLandingPage;